import { Gem, Gift, Home, Sparkles, UserRound } from "lucide-react";

const items = [
  { href: "/", label: "大廳", icon: Home },
  { href: "/newbie", label: "闖關", icon: Sparkles },
  { href: "/red-packet", label: "紅包", icon: Gift },
  { href: "/gems", label: "寶石", icon: Gem },
  { href: "/profile", label: "基本", icon: UserRound }
];

export function BottomNav() {
  const path = window.location.pathname;
  return (
    <nav className="bottom-nav">
      {items.map((item) => {
        const Icon = item.icon;
        return (
          <a href={item.href} key={item.href} className={path === item.href ? "active" : ""}>
            <Icon size={18} />
            {item.href === "/red-packet" ? <i className="nav-dot" /> : null}
            <span>{item.label}</span>
          </a>
        );
      })}
    </nav>
  );
}
